import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../../auth/auth.service';

@Directive({
  selector: '[cdsApproverProfile]'
})
export class CDSApproverProfileDirective {
  private hasView: boolean = false;

  constructor(private container: ViewContainerRef,
    private template: TemplateRef<any>,
    private authService: AuthService
  ) { }


  @Input() set cdsApproverProfile(profile: { userProfileOwner: ServerModels.UserInfoViewModel }) {
    const isSelf: boolean = !profile.userProfileOwner;

    if (isSelf) {
      if (this.authService.isCDSApprover()) {
        this.container.clear();
        this.hasView = false;
      } else if(!this.hasView) {
        this.container.createEmbeddedView(this.template);
        this.hasView = true;
      }
    } else {
      if (profile.userProfileOwner.Roles.some((r: ServerModels.RoleViewModel) => r.Name == 'CDS Approver') && profile.userProfileOwner.UserTypeName === 'StateLocalLE') {
        if (this.authService.hasRole(['NESS Administrator']) && !this.hasView) {
          this.container.createEmbeddedView(this.template);
          this.hasView = true;
        } else if (this.authService.hasRole(['NESS Administrator']) && this.hasView) {
          this.hasView = true;
        } else if(this.hasView) {
          this.container.clear();
          this.hasView = false;
        }
      } else if(!this.hasView) {
        this.container.createEmbeddedView(this.template);
        this.hasView = true;
      }
    }
  }
}
